import { useEffect, useState } from 'react'

const isClientRender = typeof window !== 'undefined'

export const useLocalStorage = <T = any>(key: string, initialValue: T) => {
  const item = isClientRender ? window?.localStorage?.getItem(key) : null

  const [storedValue, setStoredValue] = useState(item || initialValue)

  useEffect(() => {
    if (item) setStoredValue(item)
  }, [item])

  const setValue = (value: T) => {
    try {
      const valueToStore = value instanceof Function ? value(storedValue) : value

      setStoredValue(valueToStore)
      if (isClientRender) {
        const storage = window?.localStorage

        if (valueToStore != null) {
          storage?.setItem(key, valueToStore)
        } else {
          storage?.removeItem(key)
        }
      }
    } catch (error) {
      console.error(`Local storage Error: ${error}`)
    }
  }

  return { storedValue, setValue }
}
